var _g, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLookout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_17050_48349)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#EEEFF1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3747 23.314L22.3435 19.7957C22.1367 19.4369 22.0808 19.0106 22.1882 18.6106C22.2955 18.2106 22.5573 17.8696 22.916 17.6625C23.2747 17.4554 23.7009 17.3992 24.101 17.5062C24.5011 17.6132 24.8424 17.8747 25.0498 18.2332L28.1748 23.6459",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9815 25.4185L19.0127 20.2765C18.9099 20.0988 18.8432 19.9026 18.8162 19.6991C18.7893 19.4955 18.8028 19.2887 18.8558 19.0904C18.9089 18.892 19.0005 18.7061 19.1254 18.5432C19.2504 18.3803 19.4062 18.2436 19.584 18.141C19.7618 18.0383 19.9581 17.9717 20.1616 17.945C20.3652 17.9182 20.572 17.9318 20.7703 17.9851C20.9686 18.0383 21.1544 18.13 21.3172 18.2551C21.48 18.3802 21.6165 18.5361 21.7191 18.714L24.3753 23.3148",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0315 27.9141C26.6171 27.1964 26.5048 26.3434 26.7193 25.5428C26.9338 24.7423 27.4576 24.0597 28.1753 23.6453L27.3941 22.2921C27.2913 22.1144 27.2245 21.9182 27.1976 21.7147C27.1707 21.5112 27.1841 21.3043 27.2372 21.106C27.2902 20.9077 27.3818 20.7217 27.5068 20.5588C27.6317 20.3959 27.7875 20.2593 27.9653 20.1566C28.1431 20.054 28.3394 19.9873 28.543 19.9606C28.7465 19.9338 28.9533 19.9475 29.1516 20.0007C29.3499 20.0539 29.5358 20.1457 29.6986 20.2707C29.8614 20.3958 29.9979 20.5518 30.1004 20.7296L31.6629 23.436C32.0735 24.1468 32.3401 24.9315 32.4473 25.7454C32.5546 26.5592 32.5005 27.3862 32.2882 28.1791C32.0758 28.9721 31.7093 29.7154 31.2096 30.3667C30.7099 31.0179 30.0869 31.5644 29.3759 31.9748C28.665 32.3853 27.8803 32.6517 27.0664 32.7588C26.2525 32.8659 25.4255 32.8116 24.6327 32.599C23.8398 32.3865 23.0965 32.0198 22.4454 31.52C21.7942 31.0202 21.2479 30.397 20.8376 29.686L17.8688 24.544C17.6621 24.1851 17.6062 23.7588 17.7136 23.3588C17.8209 22.9588 18.0827 22.6178 18.4414 22.4107C18.8001 22.2036 19.2263 22.1474 19.6264 22.2544C20.0265 22.3614 20.3678 22.6229 20.5752 22.9815L21.9814 25.4171",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3355 33.7509C20.2761 33.0159 19.3931 32.055 18.75 30.9375",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 17.4219C29.4631 17.4218 30.1636 17.6095 30.7812 17.9661C31.3987 18.3228 31.9114 18.8358 32.2676 19.4535",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_17050_48349",
    x: -27.1828,
    y: -27.1828,
    width: 104.366,
    height: 104.366,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 13.5914
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_17050_48349"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_17050_48349",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLookout);
export default __webpack_public_path__ + "static/media/lookout.584fc08b598d3d9613a6fdf0e3b145fb.svg";
export { ForwardRef as ReactComponent };